<div class="position-relative" [ngStyle]="{ 'background-color': backgroundColor,'background-image': backgroundColor }" id="{{position}}"
  [ngClass]="activatePadding?'header-padding-top':''">
  <div>
    <header class="app-header-background header pt-40 pb-40"
      [ngStyle]="{ 'background-color': backgroundColor,'background-image': backgroundColor }">
      <div class="app-header-headline">
        <h1 *ngIf="title" [class]="'center mb-20 '+titleSize" [ngStyle]="{ 'color': textColor }"> <img
            class="icons-social-media"
            src="https://s3.amazonaws.com/ai-images.sitecreator.io/assets/img/logos/instagram-icon.png" alt="">
          {{title}}</h1>
      </div>
      <div fxLayout="row" fxLayoutAlign="center center">
        <div fxFlexAlign="center">
          <div *ngIf="!loading">
            <ng-container *ngIf="userInstagramData && instagramEnabled; else nolink">
              <div class="row" *ngIf="userInstagramData && instagramEnabled">
                <span *ngFor="let data of userInstagramData.data.slice(0,displayLimit); let i = index"
                  (click)="openImage(i)">
                  <div *ngIf="data.media_type=='VIDEO' || data.media_type=='IMAGE'" class="imgContainer">
                    <!-- <app-vjs-player *ngIf="data.media_type=='VIDEO' || data.media_type=='IMAGE'" [options]="{autoplay: true, controls: true, sources: [{ src: data.media_url, type: 'video/mp4' }]}"></app-vjs-player> -->
                    <video *ngIf="data.media_type=='VIDEO'" controls autoplay 
                      style='width: 100%; max-height: 100%; display: block !important; margin: auto;pointer-events: none;'>
                      <source src='{{ data.media_url }}' type='video/mp4'>
                      Your browser does not support the video tag.
                  </video>
                    <img *ngIf="data.media_type=='IMAGE'" src="{{ data.media_url }}" />
                    <div class="imageLikesComments">
                      <div class="post-info">
                        <div class="caption">
                          <p>{{ data.caption }}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </span>
                <!-- <img *ngFor="let data of userInstagramData.data" class="imgContainer" src="{{ data.media_url }}" alt=""> -->
              </div>
              <a class="mt-30 mat-focus-indicator app-button mat-raised-button mat-button-base ng-star-inserted"
                style="margin-top:15px" *ngIf="userInstagramData.data.length > displayLimit" (click)="loadMore()"
                rel="noopener">Show more</a>
            </ng-container>
            <ng-template #nolink>
              <!-- <img *ngFor="let img of imageList" class="imgContainer" [src]="img" (error)="updateUrl($event)"/> -->
            </ng-template>
          </div>
        </div>
      </div>
    </header>
  </div>
</div>